// A venue entry returned by `/venue/applications/my-all` is either one the
// user OWNS (no `staff_role` field) or the single venue they're a staff/admin
// member of elsewhere (`staff_role: 'admin' | 'staff'`). This label is shown
// next to each entry in the merged venue-switcher dropdown so it's always
// obvious which "hat" tapping that entry will put the user in.
export const getVenueRoleBadge = (venue) => {
  if (!venue?.staff_role) return 'Owner';
  return venue.staff_role === 'admin' ? 'Admin' : 'Staff';
};
